import { render, staticRenderFns } from "./ActiveAccount.vue?vue&type=template&id=1fb1cabd"
import script from "./ActiveAccount.vue?vue&type=script&lang=js"
export * from "./ActiveAccount.vue?vue&type=script&lang=js"
import style0 from "./ActiveAccount.vue?vue&type=style&index=0&id=1fb1cabd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports